<template>
    <div>

        <div class="container-fluid">
            <div class="row">

                <div class="col-12 white rounded" style="padding: 10px; margin: 5px">
                    <div class="container-fluid">
                        <div class="row">
                            <div class="col-lg-2 col-md-2 col-sm-12 col-xs-12">
                                <datepicker :monday-first="true" :language="es" v-model="date" format-date="dd/MM/yyyy"></datepicker>




                            </div>
                            <div class="col-lg-2 col-md-2 col-sm-12 col-xs-12">
                                <toggle-button @change="filtroWeb" tabindex="20" v-model="web" color="#e3985f" :width="150" :height="40" :labels="{checked: 'Córdoba', unchecked: 'Sevilla'}" :sync="true"/>
                            </div>
                            <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
                                <v-select
                                        v-model="selectTours"
                                        :items="tours"
                                        item-text="text"
                                        item-value="idioma"
                                        label="Tour seleccionado: "
                                        persistent-hint
                                        return-object
                                        outline

                                ></v-select>
                            </div>
                            <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
                                <v-select
                                        v-model="empleado"
                                        :items="empleados"
                                        label="Empleado:"
                                        outline
                                ></v-select>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                <vue-numeric class="form-control" currency="" v-model="personas" placeholder="Núm. Personas" separator="."></vue-numeric>
                            </div>
                            <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                <vue-numeric currency-symbol-position="suffix" class="form-control" currency="€" separator="." decimal-separator="," v-model="economico" :precision="precision"></vue-numeric>
                            </div>

                        </div>

                        <div class="clearfix"></div>

                        <div class="row" style="margin-top: 20px">

                            <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">

                            </div>

                            <div v-if="divGuardar" class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
                                <span class="btn btn-success" v-on:click="guardarDatos">Guardar Datos</span>
                            </div>

                            <div v-if="!divGuardar" class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
                                <span class="btn btn-success" v-on:click="editarDatos">Editar Datos</span>
                                <span class="btn btn-info" v-on:click="cancelarEditarDatos">Cancelar</span>
                            </div>

                            <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">

                            </div>



                        </div>

                        <div id="people">
                            <v-client-table ref="myTable" :data="tableData" :columns="columns" :options="optionsTable">

                                <a slot="borrar" v-on:click="modalBorrar(props.row.id)" slot-scope="props" >Borrar</a>
                                <a slot="editar" v-on:click="editarLinea(props.row)" slot-scope="props" >Editar</a>


                            </v-client-table>
                        </div>


                    </div>
                </div>
            </div>
            <div class="clearfix"></div>

        </div>


        <!--MODALES-->
        <div v-if="showModal">
            <transition name="showModal">
                <div class="modal-mask">
                    <div class="modal-wrapper">

                        <div class="modal-lg" style="margin: 1.75rem auto" role="document">
                            <div class="modal-content">
                                <div class="modal-header">
                                    <h5 class="modal-title">Borrar</h5>
                                </div>
                                <div class="modal-body">
¿Está seguro?
                                </div>
                                <div class="modal-footer">
                                    <button type="button" class="btn btn-danger" @click="borrarLinea">Si</button>
                                    <button type="button" class="btn btn-secondary" @click="cancelarBorrar">No</button>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </transition>
        </div>
        <!--EOF MODALES-->


    </div>

</template>

<script>

//import MonthPicker from 'vue-month-picker'
import axios from 'axios'
import LineChart from './personasMes.js'
import { ToggleButton } from 'vue-js-toggle-button'
import Datepicker from 'vuejs-datepicker';
import {es, en} from 'vuejs-datepicker/dist/locale'
//axios.defaults.baseURL = 'http://localhost/FreeTourControl/api'
axios.defaults.baseURL = 'https://app.freetoursevilla.es/api'

export default {
    components: {
        LineChart,
      ToggleButton,
      Datepicker
    },
  data () {
    return {

      date: new Date(),
      es: es,
      precision:2,

        id:0,
        idBorrar:0,
      personas:0,
      economico:'',

      web: false,//false es sevilla y true es cordoba
      selectTours: { text: 'Free Tour Monumental (Español)', idioma: 'Casco Histórico_1', idTour: 1 },
      tours: [
        { text: 'Free Tour Monumental (Español)', idioma: 'Casco Histórico_1', idTour: 1 },
        { text: 'Free Tour Monumental (Ingles)', idioma: 'Casco Histórico_2', idTour: 2 },
        { text: 'Free Tour Misterios de Santa Cruz (Español)', idioma: 'Santa Cruz_1', idTour: 5 },
        { text: 'Free Tour Leyendas de Triana (Español)', idioma: 'Triana_1', idTour: 7 },
        { text: 'Free Tour Misterios de Santa Cruz (Ingles)', idioma: 'Santa Cruz_2', idTour: 6 },
        { text: 'Flamenco Tour (Español)', idioma: 'Flamenco Tour_1', idTour: 9 },
        { text: 'Flamenco Tour (Ingles)', idioma: 'Flamenco Tour_2', idTour: 10 },
        { text: 'Bike Tour (Español)', idioma: 'Bike Tour_1', idTour: 11 },
        { text: 'Bike Tour (Ingles)', idioma: 'Bike Tour_2', idTour: 12 },
        { text: 'Free Tour Leyendas de Triana (Ingles)', idioma: 'Triana_2', idTour: 8 },
        { text: 'Tour de las 12 (Español)', idioma: 'Tour de las 12_1', idTour: 3 },
        { text: 'Tour de las 12 (Ingles)', idioma: 'Tour de las 12_2', idTour: 4 },
        { text: 'Flamenco Ticket', idioma: 'Flamenco Ticket (Sin distinción de idioma)_1', idTour: 13 },
        { text: 'Especial', idioma: 'Especial_1', idTour: 14 },
        { text: 'Alcázar', idioma: 'Alcázar_1', idTour: 15 },
        { text: 'Especial Italiano', idioma: 'Especial Italiano_1', idTour: 16 },
        { text: 'Free Tour Monumental (Francés)', idioma: 'Casco Histórico_3', idTour: 21 },
        { text: 'Free Tour Misterios de Santa Cruz 12:45h (Español)', idioma: 'Santa Cruz 12-45_1', idTour: 22 },
        { text: 'Free Tour Misterios de Santa Cruz 12:45h (Inglés)', idioma: 'Santa Cruz 12-45_2', idTour: 23 },
        { text: 'Viator', idioma: 'Viator (Sin distinción de idioma)_1', idTour: 24 },
        { text: 'Ronda y Granada', idioma: 'Ronda y Granada (Sin distinción de idioma)_1', idTour: 25 }
      ],
      empleados:[],
      empleado:"",

      columns: ['id', 'fecha', 'empleado', 'tour', 'personas', 'importe', 'web', 'idioma','editar','borrar'],
      tableData:[],
      optionsTable: {
        // see the options API
        filterable: true,
        sortable:true,
        texts:{
          count:"Mostrando {from} a {to} de {count} lineas|{count} lineas|Una linea",
          first:'Primero',
          last:'Último',
          filter:"Filtro:",
          filterPlaceholder:"Buscar",
          limit:"Lineas:",
          page:"Página:",
          noResults:"No hay resultados",
          filterBy:"Filtrar por {column}",
          loading:'Cargando...',
          defaultOption:'Seleccionar {column}',
          columns:'Columnas'
        },
      },
        showModal: false,
        divGuardar : true,
      }
  },
    created() {



        this.getEmpleados();
        this.getDatos();
    },
    mounted () {


    },
  methods: {
        guardarDatos(){



          let formData = new FormData();

          formData.append('day', this.date.getDate());
          formData.append('month', this.date.getMonth()+1);
          formData.append('year', this.date.getFullYear());
          formData.append('tour', this.selectTours.idioma);
          formData.append('idTour', this.selectTours.idTour);
          formData.append('web', this.web);
          formData.append('empleado', this.empleado);
          formData.append('personas', this.personas);
          formData.append('economico', this.economico);

          axios.post('/save.dato.php', formData)
            .then(response => {

              alert("GUARDADO");

              this.personas=0;
              this.economico='';
              //this.date = new Date();





            })
            .catch(error => {
              console.log(error);
            })



        },
        filtroWeb(){

          if(!this.web){
            this.selectTours = { text: 'Free Tour Monumental (Español)', idioma: 'Casco Histórico_1' };
            this.tours= [
              { text: 'Free Tour Monumental (Español)', idioma: 'Casco Histórico_1', idTour: 1 },
              { text: 'Free Tour Monumental (Ingles)', idioma: 'Casco Histórico_2', idTour: 2 },
              { text: 'Free Tour Misterios de Santa Cruz (Español)', idioma: 'Santa Cruz_1', idTour: 5 },
              { text: 'Free Tour Leyendas de Triana (Español)', idioma: 'Triana_1', idTour: 7 },
              { text: 'Free Tour Misterios de Santa Cruz (Ingles)', idioma: 'Santa Cruz_2', idTour: 6 },
              { text: 'Flamenco Tour (Español)', idioma: 'Flamenco Tour_1', idTour: 9 },
              { text: 'Flamenco Tour (Ingles)', idioma: 'Flamenco Tour_2', idTour: 10 },
              { text: 'Bike Tour (Español)', idioma: 'Bike Tour_1', idTour: 11 },
              { text: 'Bike Tour (Ingles)', idioma: 'Bike Tour_2', idTour: 12 },
              { text: 'Free Tour Leyendas de Triana (Ingles)', idioma: 'Triana_2', idTour: 8 },
              { text: 'Tour de las 12 (Español)', idioma: 'Tour de las 12_1', idTour: 3 },
              { text: 'Tour de las 12 (Ingles)', idioma: 'Tour de las 12_2', idTour: 4 },
              { text: 'Flamenco Ticket', idioma: 'Flamenco Ticket (Sin distinción de idioma)_1', idTour: 13 },
              { text: 'Especial', idioma: 'Especial_1', idTour: 14 },
              { text: 'Alcázar', idioma: 'Alcázar_1', idTour: 15 },
              { text: 'Especial Italiano', idioma: 'Especial Italiano_1', idTour: 16 },
              { text: 'Free Tour Monumental (Francés)', idioma: 'Casco Histórico_3', idTour: 21 },
              { text: 'Free Tour Misterios de Santa Cruz 12:45h (Español)', idioma: 'Santa Cruz 12-45_1', idTour: 22 },
              { text: 'Free Tour Misterios de Santa Cruz 12:45h (Inglés)', idioma: 'Santa Cruz 12-45_2', idTour: 23 },
              { text: 'Viator', idioma: 'Viator (Sin distinción de idioma)_1', idTour: 24 },
              { text: 'Ronda y Granada', idioma: 'Ronda y Granada (Sin distinción de idioma)_1', idTour: 25 }
            ];
          }else{
            this.selectTours = { text: 'Free Tour Monumental (Español)', idioma: 'Casco Histórico_1', idTour: 17 };
            this.tours= [
              { text: 'Free Tour Monumental (Español)', idioma: 'Casco Histórico_1', idTour: 17 },
              { text: 'Free Tour Monumental (Ingles)', idioma: 'Casco Histórico_2', idTour: 18 },
              { text: 'Free Tour Leyendas Juderia (Español)', idioma: 'Leyendas Juderia_1', idTour: 19 },
              { text: 'Free Tour Leyendas Juderia (Ingles)', idioma: 'Leyendas Juderia_2', idTour: 20 }
              ];
          }

          this.getEmpleados();
          this.getDatos();

        },
        getEmpleados(){
        let formData = new FormData();

        formData.append('month', this.date.getMonth()+1);
        formData.append('year', this.date.getFullYear());
        formData.append('tour', this.selectTours.idioma);
        formData.append('web', this.web);

        axios.post('/get.empleados.dato.php', formData)
            .then(response => {

                this.empleados = response.data;
                this.empleado = response.data[0];




            })
            .catch(error => {
                console.log(error);
            })

    },
      editarDatos(){
          let formData = new FormData();

          formData.append('day', this.date.getDate());
          formData.append('month', this.date.getMonth()+1);
          formData.append('year', this.date.getFullYear());
          formData.append('tour', this.selectTours.idioma);
          formData.append('idTour', this.selectTours.idTour);
          formData.append('web', this.web);
          formData.append('id', this.id);
          formData.append('empleado', this.empleado);
          formData.append('personas', this.personas);
          formData.append('economico', this.economico);

          axios.post('/edit.dato.php', formData)
              .then(response => {

                  alert("EDITADO");

                  this.personas=0;
                  this.economico='';
                  this.divGuardar=true;
                  this.getDatos();
                  this.id = 0;





              })
              .catch(error => {
                  console.log(error);
              })
      },
      cancelarEditarDatos(){
            this.divGuardar = true;
          this.personas = 0;
          this.economico = 0;
          this.id = 0;
      },
      editarLinea(dato){
          //this.showModal = true;
          if(dato.web == "Sevilla"){
              this.web = false;
          }else{
              this.web = true;
          }
        if(!this.web){
          this.selectTours = { text: 'Free Tour Monumental (Español)', idioma: 'Casco Histórico_1' };
          this.tours= [
            { text: 'Free Tour Monumental (Español)', idioma: 'Casco Histórico_1', idTour: 1 },
            { text: 'Free Tour Monumental (Ingles)', idioma: 'Casco Histórico_2', idTour: 2 },
            { text: 'Free Tour Misterios de Santa Cruz (Español)', idioma: 'Santa Cruz_1', idTour: 5 },
            { text: 'Free Tour Leyendas de Triana (Español)', idioma: 'Triana_1', idTour: 7 },
            { text: 'Free Tour Misterios de Santa Cruz (Ingles)', idioma: 'Santa Cruz_2', idTour: 6 },
            { text: 'Flamenco Tour (Español)', idioma: 'Flamenco Tour_1', idTour: 9 },
            { text: 'Flamenco Tour (Ingles)', idioma: 'Flamenco Tour_2', idTour: 10 },
            { text: 'Bike Tour (Español)', idioma: 'Bike Tour_1', idTour: 11 },
            { text: 'Bike Tour (Ingles)', idioma: 'Bike Tour_2', idTour: 12 },
            { text: 'Free Tour Leyendas de Triana (Ingles)', idioma: 'Triana_2', idTour: 8 },
            { text: 'Tour de las 12 (Español)', idioma: 'Tour de las 12_1', idTour: 3 },
            { text: 'Tour de las 12 (Ingles)', idioma: 'Tour de las 12_2', idTour: 4 },
            { text: 'Flamenco Ticket', idioma: 'Flamenco Ticket (Sin distinción de idioma)_1', idTour: 13 },
            { text: 'Especial', idioma: 'Especial_1', idTour: 14 },
            { text: 'Alcázar', idioma: 'Alcázar_1', idTour: 15 },
            { text: 'Especial Italiano', idioma: 'Especial Italiano_1', idTour: 16 },
            { text: 'Free Tour Monumental (Francés)', idioma: 'Casco Histórico_3', idTour: 21 },
            { text: 'Free Tour Misterios de Santa Cruz 12:45h (Español)', idioma: 'Santa Cruz 12-45_1', idTour: 22 },
            { text: 'Free Tour Misterios de Santa Cruz 12:45h (Inglés)', idioma: 'Santa Cruz 12-45_2', idTour: 23 },
            { text: 'Viator', idioma: 'Viator (Sin distinción de idioma)_1', idTour: 24 },
            { text: 'Ronda y Granada', idioma: 'Ronda y Granada (Sin distinción de idioma)_1', idTour: 25 }
          ];
        }else{
          this.selectTours = { text: 'Free Tour Monumental (Español)', idioma: 'Casco Histórico_1', idTour: 17 };
          this.tours= [
            { text: 'Free Tour Monumental (Español)', idioma: 'Casco Histórico_1', idTour: 17 },
            { text: 'Free Tour Monumental (Ingles)', idioma: 'Casco Histórico_2', idTour: 18 },
            { text: 'Free Tour Leyendas Juderia (Español)', idioma: 'Leyendas Juderia_1', idTour: 19 },
            { text: 'Free Tour Leyendas Juderia (Ingles)', idioma: 'Leyendas Juderia_2', idTour: 20 }
          ];
        }

          let formData = new FormData();

          formData.append('month', this.date.getMonth()+1);
          formData.append('year', this.date.getFullYear());
          formData.append('tour', this.selectTours.idioma);
          formData.append('web', this.web);

          axios.post('/get.empleados.dato.php', formData)
              .then(response => {

                  this.empleados = response.data;


                  this.personas = dato.personas;
                  this.economico = dato.importe;

                  this.id = dato.id;
                  this.selectTours = { text: dato.textTour, idioma: dato.idiomaTour, idTour: dato.idTourTour };

                  this.date = new Date(dato.anno,dato.mes,dato.dia);//dato.fechaFormat;
                  this.divGuardar = false;


                this.empleado = dato.empleado;


              })
              .catch(error => {
                  console.log(error);
              })

      },
      modalBorrar(id){
          this.showModal=true;
          this.idBorrar=id;
      },
      cancelarBorrar(){
          this.showModal=false;
          this.idBorrar=0;
      },
    borrarLinea(){

      let formData = new FormData();

      formData.append('id', this.idBorrar);

      axios.post('/delete.dato.php', formData)
        .then(response => {
            this.idBorrar=0;
            this.showModal=false;
          this.getDatos();
        })
        .catch(error => {
          console.log(error);
        })
    },
    getDatos(){

        let formData = new FormData();
        formData.append('web', this.web);

      axios.post('/get.datos.php', formData)
        .then(response => {

          this.tableData = response.data;




        })
        .catch(error => {
          console.log(error);
        })

    },
        complete (index) {
          this.list[index] = !this.list[index]
        }
  }
}
</script>
<style>
    .month-picker-input-container{
        width: 100% !important;
    }
    .month-picker-input{
        background-color: #FFF;
        width: 100% !important;
    }
    .month-picker-container{
        background-color: #FFF;
        z-index: 99998;
        width: 100% !important;
    }
    .month-picker-container button{
        background-color: #FFF;
        z-index: 99999;
    }
    .month-picker-container button:hover{
        background-color: #FFF;
        z-index: 99999;
    }
    .fondoBlanco{
        background-color: #fff;

        border-color: #fff;

        color: rgba(0,0,0,.87);
        box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.14);

        border-radius: 3px;
    }
    .modal-mask {
        position: fixed;
        z-index: 9998;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, .5);
        display: table;
        transition: opacity .3s ease;
    }

    .modal-wrapper {
        display: table-cell;
        vertical-align: middle;
    }
    .hidden{
        display: none;
    }
</style>